import { VHeaders } from '@/models/pagedlistmodel';

export function getheaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.ro') as string,
      value: 'repairOrderNumber',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.customerName') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.lastVin') as string,
      value:
        'vin.length>10? item.vin.substring(item.vin.length-8,item.vin.length):item.vin',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.closeDate') as string,
      value: 'finalCloseDate',
      fieldType: 'date',
      sortable: false,
      format: 'MMMM Do YYYY',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.serviceWriter') as string,
      value: `serviceWriter`,
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t('closedRepairOrders.roGrid.actions') as string,
      sortable: false,
    },
  ];
}

export function getClosedListheaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.ro') as string,
      value: 'repairOrderNumber',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.customerName') as string,
      value: 'customerName',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.lastVin') as string,
      value: 'vin.length>10? item.vin.substring(item.vin.length-8,item.vin.length):item.vin',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.closeDate') as string,
      value: 'finalCloseDate',
      fieldType: 'date',
      sortable: false,
      format: 'MMMM Do YYYY',
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roGrid.serviceWriter') as string,
      value: `serviceWriter`,
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: 'Action',
      sortable: false,
    },
  ];
}

export function getCustomerHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.firstName') as string,
      value: 'firstName',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.lastName') as string,
      value: 'lastName',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.address1') as string,
      value: 'address1',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.city') as string,
      value: 'city',
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.state') as string,
      value: `state`,
      sortable: false,
    },
    {
      align: 'left',
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.zipCode') as string,
      value: `zipCode`,
      sortable: false,
    },
    {
      align: 'left',
      sortable: false,
      text: vm.$parent.$t('closedRepairOrders.roCustomerGrid.phone') as string,
      value: `cellPhone`,
      filters: [
        (val, item: any) => {
          return `C: ${item.cellPhone && item.cellPhone !== '0' ? item.cellPhone : 'N/A'
            }
                  \n W: ${item.businessPhone && item.businessPhone !== '0'
              ? item.businessPhone
              : 'N/A'
            }
                  \n H: ${item.homePhone && item.homePhone !== '0'
              ? item.homePhone
              : 'N/A'
            }`;
        },
      ],
    },
    {
      align: 'center',
      isNotDataProp: true,
      sortable: false,
      text: 'Action',
    },
  ];
}

export function getSendMessageHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.date') as string,
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.from') as string,
      value: 'messageJson.from',

    },
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.to') as string,
      value: 'messageJson.to',
    },
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.message') as string,
      value: 'messageJson.textJson.body',
    },
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.status') as string,
      value: `messageJson.status`,
    },
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOSendMessageGrid.attachment') as string,
      isNotDataProp: true,
      sortable: false,
    },
  ];
}

export function getAttachmentHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      text: vm.$parent.$t('sendMessage.rOAttachmentDetailGrid.name') as string,
      value: 'uri.substring(item.uri.lastIndexOf("/")+1,item.uri.length)',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t('sendMessage.rOAttachmentDetailGrid.action') as string,
      sortable: false,
    },
  ];
}
